
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import FormGroup from "@/components/form/FormGroupNew.vue";
import StateProvinceSelect from "@/components/autocompleteMultiselects/StateProvinceSelectNew.vue";
import DropdownOption from "@/entities/DropdownOption";
import getStateProvinceSelectTitle from "@/helpers/locations/getStateProvinceSelectTitle";
import isAllStatesOfPrimaryCountry from "@/helpers/locations/stateOfPrimaryCountry";
import isPrimaryCountryStates from "@/helpers/locations/primaryCountryState";

@Component({
  components: {
    StateProvinceSelect,
    FormGroup,
  },
})
export default class RegionInput extends Vue {
  @Prop({ type: Array, default: () => [] }) countries!: DropdownOption[];
  @Prop({ type: Array, default: () => [] }) value!: DropdownOption[];
  @Prop({ type: Array, default: () => [] }) readonly errors!: string[];
  @Prop({ type: Boolean, default: false }) readonly required!: boolean;
  @Prop({ type: Boolean, default: false }) multiple!: boolean;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  @Prop({ type: Boolean, default: true }) isIcon!: boolean;
  @Prop({ type: String, default: undefined }) readonly shouldFullWidth?: string;
  @Prop({ type: String, default: undefined }) readonly id?: string;
    @Prop({ type: String, default: undefined }) readonly title?: string
    @Prop({ type: String, default: 'Search by region' }) readonly placeholder?: string
    @Prop({ type: String, default: '' }) readonly groupClasses?: string

  region: string = "";
  stateOption: DropdownOption[] = [];

  get countryName(): string {
    return this.countries[0]?.name || "";
  }
  get placeholderText(): string {
    return this.placeholder;
  }
  get primaryCountry(): boolean {
    const countryNames = this.countries.map(country => country.name);
    return isAllStatesOfPrimaryCountry(countryNames);
  }

  get stateProvinceSelectTitle(): string {
    if (this.required) {
      return `${getStateProvinceSelectTitle(this.countries)}*`;
    }

    return getStateProvinceSelectTitle(this.countries, this.multiple);
  }

  get countriesNames(): string[] {
    return this.countries.map((country) => country.name);
  }

  get statesNames(): string[] {
    return this.stateOption.map((state) => state.name);
  }

  @Watch("value", { immediate: true })
  onValueChange() {
    if (this.primaryCountry) {
      this.stateOption = this.value;
      return;
    }

    this.region = this.value[0]?.name || "";
  }

  @Watch("countries")
  onCountriesChange(newCountry: DropdownOption[], oldCountry: DropdownOption[]) {
    if (newCountry.length === oldCountry.length) {
      return;
    }

    if (!this.multiple) {
      if (newCountry[0]?.name || newCountry[0]?.name === oldCountry[0]?.name) {
        return;
      }
    }

    if (this.countries.length > 2) {
      return;
    }

    if (isAllStatesOfPrimaryCountry(this.countriesNames)) {
      if (isPrimaryCountryStates(this.statesNames)) {
        return;
      }
    }

    this.region = "";
    this.stateOption = [];
  }

  @Watch("region")
  onRegionChange() {
    this.$emit("input", [{ id: this.region, name: this.region }]);
  }

  handleEnter() {
    this.$emit("enter", [{ id: this.region, name: this.region }]);
  }

  @Watch("stateOption")
  onStateChange() {
    this.$emit("input", this.stateOption);
  }
}
